import * as React from 'react';
import cn from 'clsx';
import { IconFunctionalSuccessCircle16, LinkButton, ArticleHeading1 } from '@cian/ui-kit';

import { withDeviceType, IWithDeviceTypeProps } from '../../utils/withDeviceType';
import { BigHeading } from '../BigHeading';
import { ListWithIcons } from '../ListWithIcons';
import { IPriceData } from '../../types/promoInfo/priceData';
import { NBSP } from '../../constants/symbols';
import { ResizableWrap } from '../ResizableWrap';

import * as styles from './styles.css';

interface IDealPriceSectionProps extends IWithDeviceTypeProps {
  priceData: IPriceData;
  dealFormUrl: string;
  details: string[];
  priceListUrl: string;
  onCreateDealButtonClick(): void;
}

/**
 * Секция "Сколько стоит Циан.Сделка".
 */
const DealPriceSection: React.FC<React.PropsWithChildren<IDealPriceSectionProps>> = ({
  deviceType,
  isPhone,
  details,
  priceData,
  priceListUrl,
  onCreateDealButtonClick,
  dealFormUrl,
}) => {
  const Heading = isPhone ? ArticleHeading1 : BigHeading;

  return (
    <div className={cn(styles['container'], styles[deviceType])}>
      <div className={cn(styles['left-side'], styles[deviceType])}>
        <Heading as="h2" color="white_100">
          Сколько стоит Циан.Сделка
        </Heading>
        <div className={styles['details']}>
          <ListWithIcons.List>
            {details.map((detail, i) => (
              <ListWithIcons.Item
                key={i}
                textColor="white_100"
                icon={
                  <ResizableWrap height={24}>
                    <IconFunctionalSuccessCircle16 color="gray10_100" />
                  </ResizableWrap>
                }
              >
                {detail}
              </ListWithIcons.Item>
            ))}
          </ListWithIcons.List>
        </div>
      </div>

      <div className={cn(styles['right-side'], styles[deviceType])}>
        <div className={styles['price']} aria-label="Цена" data-testid="deal-price">
          <span>
            от <span className={styles['initial-price']}>{priceData.initialPrice}</span>
          </span>
          <span>+ госпошлина</span>
          {priceData.fullPrice && (
            <span className={styles['full-price']}>
              Общая сумма услуги —{NBSP}
              <a
                data-testid="price-list-link"
                className={styles['price-list-link']}
                href={priceListUrl}
                target="_blank"
                rel="noreferrer"
              >
                {priceData.fullPrice}
              </a>
            </span>
          )}
        </div>
        <div className={styles['deal-form-button']}>
          <LinkButton href={dealFormUrl} fullWidth size="L" onClick={onCreateDealButtonClick}>
            Провести сделку
          </LinkButton>
        </div>
      </div>
    </div>
  );
};

const DealPriceSectionWithDeviceType = withDeviceType(DealPriceSection);
export { DealPriceSectionWithDeviceType as DealPriceSection };
